<script>
const userId=1940693;
  export default
  {
    userId,//用户ID
  }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue